module.exports = __webpack_public_path__ + "assets/ef569461bbf3d1791fee676cd81e20e2.png";